export const GET_POLICE_BOOK = "GET_POLICE_BOOK";
export const GET_POLICE_BOOK_SUCCESS = "GET_POLICE_BOOK_SUCCESS";
export const GET_POLICE_BOOK_ERROR = "GET_POLICE_BOOK_ERROR";
